import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { JfBreadcrumb } from "../components/JfBreadcrumb";
import { JfExplainer } from "../components/JfExplainer";
import { JsonFormatter } from "../components/JsonFormatter";

export function JsonFormatterPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <JfBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.jf_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.jf_intro()}
          </p>
        </header>

        <JsonFormatter />

        <JfExplainer
          howTo={m.jf_howto()}
          faqs={[
            { q: m.jf_faq1_q(), a: m.jf_faq1_a() },
            { q: m.jf_faq2_q(), a: m.jf_faq2_a() },
            { q: m.jf_faq3_q(), a: m.jf_faq3_a() },
            { q: m.jf_faq4_q(), a: m.jf_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
